
<!-- Справочник сейсмичности -->

<template>

	<div>
		<b-navbar class="px-0">
			<b-navbar-brand>
				<div v-if="has_history" class="d-flex align-items-center" style="gap: .75rem;">

					<b-button class="transparent" @click="go_back">

						<base-icon name="arrow long_left" />

					</b-button>
					<h3>Справочник сейсмичности</h3>

				</div>
				<h3 v-else >Справочник сейсмичности</h3>
			</b-navbar-brand>

			<b-nav pills class="ml-auto justify-content-end align-items-center">
				Справочник Укрупненные нормативы цены строительства
	
				<!-- <b-button v-if="check_roles([ 'model' ]) && !this.$root.not_editable" v-on:click="() => refresh()" variant="outline-primary" title="Обновить" v-b-tooltip.hover.bottomright><base-icon name="refresh" /></b-button> -->
			</b-nav>
		</b-navbar>

		<b-table id="table" hover :items="items" :fields="fields"/>

	</div>

</template>

<script>

import api from "../../../api"

export default
{
	data()
	{
		var fields =
		[
			{ key : "volume", label : "Наименование сборника УНЦС" },
			{ key : "year", label : "Дата сборника УНЦС" },
		]

		for(var v = 1; v <= 9; v++)
			fields.push({ key : v.toString(), label : v.toString(), thStyle: "text-align: right;", tdClass: "text-right" })

		return {

			service : "cadastral_expensive",

			items : [],
			fields : fields,

		}
	},

	mounted()
	{
		this.refresh()
	},

	computed :
	{
		has_history()
		{
			return this.$router.history.current.path != this.$router.history._startLocation
			// return window.history.length > 1
		}
	},

	methods :
	{
		refresh()
		{
			return api.call(this, this.service, "get_seismicity_alpha", {}, response => { this.items = response.data })
		},

		check_roles(roles)
		{
			return api.check_roles(this, roles)
		},

		go_back()
		{
			api.back.go(this)
		}
	}
}

</script>

